import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";
import { Checkbox } from "../../../components/ui/Checkbox";
import { useTranslation } from "react-i18next";

const CampaignTable = ({
  campaigns,
  selectedCampaigns,
  onSelectionChange,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation();
  const [hoveredMedia, setHoveredMedia] = useState(null);

  const handleSelectCampaign = (id, checked) => {
    if (checked) {
      onSelectionChange([...selectedCampaigns, id]);
    } else {
      onSelectionChange(selectedCampaigns.filter((x) => x !== id));
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      {/* ================= Desktop Table ================= */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="px-4 py-3 text-center">{t("image")}</th>
              <th className="px-4 py-3 text-center">{t("url")}</th>
              <th className="px-4 py-3 text-center">{t("product")}</th>
              <th className="px-4 py-3 text-center">{t("category")}</th>
              <th className="px-4 py-3 text-center">{t("actions")}</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-border">
            {campaigns?.map((campaign) => (
              <tr key={campaign.id} className="hover:bg-muted/30">
                {/* Image */}
                <td className="px-4 py-4 text-center">
                  <div
                    className="relative w-12 h-12 mx-auto rounded-lg overflow-hidden bg-muted"
                    onMouseEnter={() => setHoveredMedia(campaign.id)}
                    onMouseLeave={() => setHoveredMedia(null)}
                  >
                    <Image
                      src={campaign.image}
                      alt={campaign.name}
                      className="w-full h-full object-cover"
                    />
                    {hoveredMedia === campaign.id && (
                      <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                        <Icon name="Eye" size={16} color="white" />
                      </div>
                    )}
                  </div>
                </td>

                {/* URL */}
                <td className="px-4 py-4 max-w-xs">
                  <p className="text-center break-all">{campaign.url}</p>
                </td>

                {/* PRODUCT */}
                <td className="px-4 py-4 max-w-xs">
                  <p className="text-center break-all">{campaign.product_id}</p>
                </td>

                {/* CATEGORY */}
                <td className="px-4 py-4 max-w-xs">
                  <p className="text-center break-all">
                    {campaign.category_id}
                  </p>
                </td>

                {/* Actions */}
                <td className="px-4 py-4">
                  <div className="flex justify-center gap-2">
                    <button
                      className="h-8 w-8"
                      onClick={() => onEdit(campaign)}
                    >
                      <Icon name="Edit" size={14} />
                    </button>
                    <button
                      className="h-8 w-8 text-destructive"
                      onClick={() => onDelete(campaign)}
                    >
                      <Icon name="Trash2" size={14} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ================= Mobile Cards ================= */}
      <div className="md:hidden divide-y divide-border">
        {campaigns?.map((campaign) => (
          <div key={campaign.id} className="p-4">
            <div className="flex gap-3 items-start">
              <Checkbox
                checked={selectedCampaigns.includes(campaign.id)}
                onChange={(e) =>
                  handleSelectCampaign(campaign.id, e.target.checked)
                }
                className="mt-2"
              />

              <div className="flex-1 space-y-3">
                {/* Image */}
                <div className="flex justify-center">
                  <div className="w-14 h-14 rounded-lg overflow-hidden bg-muted">
                    <Image
                      src={campaign.image}
                      alt={campaign.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                {/* URL */}
                <div className="text-sm text-center break-all">
                  {campaign.url}
                </div>

                {/* Actions */}
                <div className="flex justify-center gap-3 pt-2">
                  <button
                    className="px-3 py-1 border rounded text-xs"
                    onClick={() => onEdit(campaign)}
                  >
                    {t("edit")}
                  </button>
                  <button
                    className="px-3 py-1 border rounded text-xs text-destructive"
                    onClick={() => onDelete(campaign)}
                  >
                    {t("delete")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CampaignTable;
